import { combineReducers, configureStore } from '@reduxjs/toolkit';

import serviceReducer from './slice/service';

export default configureStore({
  middleware: (getDefaultMiddleware: (arg0: { serializableCheck: boolean; }) => any) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    service: serviceReducer,
  },
});

const rootReducer = combineReducers({
  service: serviceReducer
});

export type IRootState = ReturnType<typeof rootReducer>;
